export default __webpack_public_path__ + "static/media/Offering.1402a767.svg";